import React, { useState, useEffect, useRef } from "react";
import CommonObj from "../../CommonObj";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import { Modal, Input } from "antd";
import { message } from "../../components/antdMessageBridge";
import QCIcon from "../../assets/img/svg/xqcprocessicon.svg";
import QCSliderUI from "./qc-slide";
import SliderUI from "../manifest/manifest-slide";
import { Html5QrcodeScanType } from "html5-qrcode";
import BookCoverDummy from "../../assets/img/cover.png";
import "./qc.css";
import { useAuth } from "../../auth/AuthContext";
import ErrorCommentsSlider from "../../components/errorCommentsSlider/errorcomments-slider";
import { useReworkData } from "../../components/errorCommentsSlider/userreworkdata";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import regexService, {
    removeSpaces,
} from "../../components/commonregex/regexService";
import IntakeRejectSlide from "../books/Intake-reject-slide";
import validationService from "../../components/commonvalidation/validationService";
import { showManualEntryDisabledWarning } from "../../components/commonvalidation/manualEntryWarning";
import useFieldPermissions from "../../hooks/useFieldPermissions";

const QCForm = () => {
    const [form, setForm] = useState({
        bid: "",
        title: "",
        author: "",
        publisher: "",
        isbN10: "",
        isbN13: "",
        bookPageCount: "",
        language: "",
        weight: "0.75",
        isbn: "",
        condition: "",
        content: "",
        bookFormat: "",
        eqComplexityLevel: "",
        rackAndShelf: "",
        rackShelf: "",
        comments: "",
        reasonForException: "",
        formatException: "",
        updbookPageCount: "",
        qc: "",
        bidScanTime: "",
        vendorName: "",
    });
    const [currentBidForComments, setCurrentBidForComments] = useState("");
    const [isbnInput, setIsbnInput] = useState("");
    const { accessToken, isAuthenticated } = useAuthToken();
    const [text, setText] = useState([]);
    const [batchData, setBatchData] = useState([]);
    const [showRoundNameButton, setShowRoundNameButton] = useState(false);
    const [load, setLoad] = useState(false);
    const drawerOpenedForBid = useRef(null);
    const [regexLoaded, setRegexLoaded] = useState(false);
    const [lockBidInput, setLockBidInput] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [rejectSubmissionData, setRejectSubmissionData] = useState(null);
    const { roleUserId } = useAuth();
    const { isReadOnly } = useFieldPermissions("qc");
    function filterUniqueScans(results) {
        const filteredResults = [];
        if (results.length === 0) {
            return filteredResults;
        }
        filteredResults.push(results[0]);
        for (let i = 1; i < results.length; ++i) {
            if (results[i].decodedText !== results[i - 1].decodedText) {
                filteredResults.push(results[i]);
            }
        }
        return filteredResults;
    }
    const [selectedValues, setSelectedValues] = useState([]);
    const [bookCover, setBookCover] = useState(false);
    const handleChanges = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };
    const UserDetails = JSON.parse(localStorage.getItem("user"));
    const LogoText = UserDetails?.name?.toUpperCase() || "U";
    const [masterData, setMasterData] = useState({
        bookFormat: [],
        condition: [],
        eqComplexityLevelFormula: [],
        bookFormatExceptions: [],
        formatException: [],
        language: [],
    });
    const {
        reworkDrawerVisible,
        reworkData,
        loading,
        openReworkDrawer,
        closeReworkDrawer,
        refreshReworkData,
        roundName,
        hasQcStatus,
    } = useReworkData(form.bid);

    const saveComment = async () => {
        if (!currentBidForComments.trim()) {
            message.warning("No BID selected for saving comments.");
            return;
        }
        if (!form.comments.trim()) {
            message.warning("Please enter a comment before saving.");
            return;
        }
        const payload = {
            bid: currentBidForComments,
            comments: form.comments,
            createdBy: roleUserId,
        };
        setLoad(true);
        try {
            const response = await fetch(CommonObj.Endpoints.QCInsertComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                throw new Error(`Server responded with status ${response.status}`);
            }
            message.success("Comment saved successfully!");
            setForm((prev) => ({ ...prev, comments: "" }));

            openCommentsSlider(currentBidForComments);
        } catch (error) {
            message.error(`Failed to save comment: ${error.message}`);
        } finally {
            setLoad(false);
        }
    };

    const [errors, setErrors] = useState({});
    const [activeScanner, setActiveScanner] = useState(null);
    const [decodedResults, setDecodedResults] = useState([]);
    const [visible, setVisible] = useState(false);
    const [bksvisible, setBksVisible] = useState(false);
    const [qcContentChanged, setQcContentChanged] = useState(false);
    const [commentsvisible, setCommentsVisible] = useState(false);
    const [processingMode, setProcessingMode] = useState("single");

    const [commentsList, setCommentsList] = useState([]);
    const commentCount = commentsList?.[0]?.totalRows ?? 0;

    const openCommentsSlider = async (bid) => {
        if (!bid) {
            message.warning("Please enter BID before viewing comments.");
            return;
        }

        setCurrentBidForComments(bid);
        try {
            const response = await fetch(CommonObj.Endpoints.GetComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    pageNo: 1,
                    pageSize: 10,
                    search: bid,
                }),
            });
            if (!response.ok) {
                throw new Error(`Status ${response.status}`);
            }
            const data = await response.json();
            console.log(data, "DAT");

            setCommentsList(data);
            setCommentsVisible(true);
        } catch (error) {
            message.error(`Failed to fetch comments: ${error.message}`);
        }
    };

    useEffect(() => {
        const loadRegexPatterns = async () => {
            try {
                await regexService.fetchRegexData(accessToken);
                await validationService.fetchRegexData(accessToken);
                setRegexLoaded(true);
            } catch (error) {
                console.error("Failed to load regex patterns:", error);
            }
        };

        if (accessToken) {
            loadRegexPatterns();
        }
    }, [accessToken]);

    useEffect(() => {
        const uniqueResults = filterUniqueScans(decodedResults);

        if (uniqueResults.length > 0 && activeScanner) {
            const latestResult = uniqueResults[uniqueResults.length - 1];
            const scannedValue = latestResult.decodedText;
            console.log(latestResult, "LA");

            switch (activeScanner) {
                case "ISBN":
                    setForm((prev) => ({ ...prev, isbn: scannedValue }));
                    break;
                case "BID":
                    const bidError = validationService.validateBid(scannedValue);
                    if (bidError) {
                        message.error({ content: bidError, key: "bidScanValidation" });
                        break;
                    }
                    if (document.activeElement && document.activeElement.name === "bid") {
                        setIsbnInput(prev => prev ? prev + "," + scannedValue : scannedValue);
                    } else {
                        setForm((prev) => ({ ...prev, bid: "" }));
                        setIsbnInput(scannedValue);
                        UserLogin(scannedValue);
                    }
                    break;
                case "Rack & Shelf ID":
                    setForm((prev) => ({ ...prev, rackAndShelf: scannedValue }));
                    break;
                case "New Rack & Shelf ID":
                    delete form?.NrackAndShelf;
                    setForm((prev) => ({ ...prev, NrackAndShelf: scannedValue }));
                    break;
                default:
                    break;
            }
            setActiveScanner(null);
            setDecodedResults([]);
        }
    }, [decodedResults, activeScanner]);
    useEffect(() => {
        const fetchMasterData = async () => {
            try {
                const response = await fetch(CommonObj.Endpoints.GetMasterData, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    },
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setMasterData(data);
            } catch (error) {
                console.error("Failed to fetch master data:", error);
            }
        };
        fetchMasterData();
    }, []);
    const onNewScanResult = (decodedText, decodedResult) => {
        setDecodedResults((prev) => [...prev, decodedResult]);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: "" }));
        }
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };
    useEffect(() => {
        if (
            !form.bookFormat ||
            form.content.length === 0 ||
            masterData.eqComplexityLevelFormula.length === 0
        ) {
            setForm((prev) => ({ ...prev, eqComplexityLevel: "" }));
            return;
        }

        const bookFormatObj = masterData.bookFormat.find(
            (bf) => bf.format === form.bookFormat,
        );
        if (!bookFormatObj) return;

        const selectedConditionIds = form.content
            .map((contentName) => {
                const conditionObj = masterData.condition.find(
                    (c) => c.fileType === contentName,
                );
                return conditionObj ? conditionObj.id.toString() : null;
            })
            .filter((id) => id !== null);

        let bestMatch = null;
        for (const formula of masterData.eqComplexityLevelFormula) {
            if (formula.bookFormat !== bookFormatObj.id.toString()) {
                continue;
            }

            const formulaConditions = formula.condition.split(",");

            if (
                formulaConditions.length === selectedConditionIds.length &&
                formulaConditions.every((condId) =>
                    selectedConditionIds.includes(condId),
                )
            ) {
                bestMatch = formula;
                break;
            }
        }

        if (bestMatch) {
            setForm((prev) => ({ ...prev, eqComplexityLevel: bestMatch.level }));
        } else {
            if (qcContentChanged)
                setForm((prev) => ({ ...prev, eqComplexityLevel: "" }));
        }
    }, [form.bookFormat, form.content, masterData]);
    const handleContentChange = (e) => {
        const { value, checked } = e.target;

        setForm((prev) => {
            const currentContent = form?.content;

            if (checked) {
                setQcContentChanged(true);
                return { ...prev, content: [...currentContent, value] };
            } else {
                setQcContentChanged(false);
                return {
                    ...prev,
                    content: currentContent.filter((item) => item !== value),
                };
            }
        });
    };
    const validate = () => {
        const newErrors = {};
        const bidError = validationService.validateBid(form.bid);
        if (!form.bid || !form.bid.trim()) {
            newErrors.bid = "Please Enter / Scan the BID number of the book";
        } else if (bidError) {
            newErrors.bid = bidError;
        }
        // Update Page count
        const updbookPageCountResult = validationService.validateUpdatePageCount(form.updbookPageCount);
        if (!updbookPageCountResult.isValid) newErrors.updbookPageCount = updbookPageCountResult.error;

        if (!form.qc || !form.qc.trim()) {
            newErrors.qc = "Please select QC Status";
        } else if (!form.qc || form.qc === "Fail") {
            newErrors.qc = "Please select Pass Status";
        }

        if (!form.rackAndShelf || !form.rackAndShelf?.trim()) {
            newErrors.rackAndShelf = "Rack and Shelf is required";
        } else if (
            removeSpaces(form?.rackShelf)?.toLowerCase() ===
            removeSpaces(form?.rackAndShelf)?.toLowerCase()
        ) {
            newErrors.rackAndShelf =
                "The Rack Shelf scanned must not be the same as current Rack Shelf.";
        } else if (regexLoaded) {
            const validation = regexService.validateRackShelf(
                form?.rackAndShelf?.trim(),
            );
            if (!validation.isValid) {
                newErrors.rackAndShelf =
                    "Input format invalid: No matching pattern found.";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const [isDisabled, setIsDisabled] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsDisabled(true);
        setTimeout(() => {
            setIsDisabled(false);
        }, 3000);

        if (!validate()) {
            console.log("Validation Failed:", errors);
            return;
        }
        message.destroy();
        const submissionData = {
            bid: form.bid.trim(),
            updatedPageCount: form.updbookPageCount,
            isSelfFixed: false,
            userId: roleUserId,
            rackShelf: form?.rackAndShelf != "" ? form?.rackAndShelf.trim() : form.rackShelf.trim(),
            qcStatus: 1,
            ErrorCount: "",
            ErrorCommand: "",
            comments: form.comments ? form.comments : LogoText,
            bidScanTime: form.bidScanTime,
        };

        try {
            const baseUrl = CommonObj.Endpoints.QCSubmitQCProcess;
            const response = await fetch(baseUrl, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(submissionData),
            });
            const result = await response.json();
            if (!response.ok) {
                const errorMessage = result.error || result.message || `Error ${response.status}`;
                throw new Error(errorMessage);
            }
            message.success(
                "QC Completed successfully. Books are ready for Delivery.",
            );

            setShowRoundNameButton(false);
            setIsbnInput("");
            setForm({
                bid: "",
                title: "",
                author: "",
                publisher: "",
                isbN10: "",
                isbN13: "",
                bookPageCount: "",
                updbookPageCount: "",
                language: "",
                weight: "0.75",
                isbn: "",
                condition: "",
                bookType: "",
                usedCondition: "",
                content: [],
                bookFormat: "",
                eqComplexityLevel: "",
                rackAndShelf: "",
                comments: "",
                reasonForException: "",
                formatException: "",
                rackShelf: "",
                version: "1.0",
                qc: "",
                bidScanTime: "",
                vendorName: "",
            });
            setCommentsList({});
            setErrors({});
            setShowRoundNameButton(false);
            setLockBidInput(false);
        } catch (error) {
            console.error("Error submitting form:", error.message);
            message.error({ content: error.message, duration: 5 });
        }
    };

    async function UserLogin(bid) {
        const bidfetch = await fetchBIDStatus(bid);

        if (bidfetch) {
            return;
        }

        const url = CommonObj.Endpoints.QCgetBookByBID;
        let pageName = {
            bid: bid,
            createdBy: roleUserId,
        };
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(pageName),
            });
            if (!response.ok) throw new Error(`Response status: ${response.status}`);
            const result = await response.json();

            if (result && result.length > 0) {
                const bookData = result[0];
                let bkdata = bookData?.content || form?.content;
                setErrors({});
                setForm({
                    ...form,
                    bid: bookData.bid || form.bid,
                    title: bookData.title,
                    author: bookData.author,
                    publisher: bookData.publisher,
                    isbN10: bookData.isbN10,
                    isbN13: bookData.isbN13,
                    bookPageCount: bookData.pageCount,
                    language: bookData.language,
                    weight: bookData.weight || "0.75",
                    isbn: bookData.isbn || form.isbn,
                    bookFormat: bookData.format || form.bookFormat,
                    bookType: bookData.bookType || form.bookType,
                    condition: bookData.condition || form.condition,
                    usedCondition: bookData.usedCondition || form.usedCondition,

                    formatException: bookData.formatException || form.formatException,
                    eqComplexityLevel:
                        bookData.eqComplexityLevel || form.eqComplexityLevel,
                    content: bkdata.split(","),
                    rackAndShelf: bookData.rackAndShelf || form.rackAndShelf,
                    rackShelf: bookData.rackShelf || form.rackShelf,
                    updbookPageCount: bookData.updatedPageCount || "",
                    bidScanTime: bookData.bidScanTime || "",
                    vendorName: bookData.vendorName || "",
                });
                setBookCover(bookData.bookCoverImageURL);
                fetchCommentCount(bookData.bid || bid);
                setTimeout(async () => {
                    const hasRework = await refreshReworkData(bookData.bid || bid);
                    if (hasRework) {
                        if (drawerOpenedForBid.current !== bid) {
                            drawerOpenedForBid.current = bid;
                            setShowRoundNameButton(true);
                            openReworkDrawer();
                        }
                    } else {
                        setShowRoundNameButton(false);
                    }
                }, 100);
                setLockBidInput(true);
            } else {
                setIsbnInput("");
                setForm({
                    title: "",
                    author: "",
                    publisher: "",
                    isbN10: "",
                    isbN13: "",
                    bookPageCount: "",
                    updbookPageCount: "",
                    language: "",
                    weight: "0.75",
                    isbn: "",
                    condition: "",
                    bookType: "",
                    usedCondition: "",
                    content: [],
                    bookFormat: "",
                    eqComplexityLevel: "",
                    rackAndShelf: "",
                    comments: "",
                    reasonForException: "",
                    formatException: "",
                    rackShelf: "",
                    version: "1.0",
                    qc: "",
                    bidScanTime: "",
                    vendorName: "",
                });
                setCommentsList({});
                setErrors({});
                setLockBidInput(false);
            }
        } catch (error) {
            setShowRoundNameButton(false);
            setLockBidInput(false);
            console.error(error.message);
        }
    }

    const fetchBIDStatus = async (bid) => {
        const url = CommonObj.Endpoints.GetQCBIDStatus;

        const requestData = {
            bid: bid,
            createdBy: roleUserId,
        };

        try {
            const response = await fetch(url, {
                method: "POST",
                mode: "cors",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            if (response.ok) {
                const errorResponse = await response.json();
                if (errorResponse.message) {
                    message.error(errorResponse.message);
                    resetFormState()
                    return true;
                } else {
                    return false;
                }
            } else if (!response.ok) {
                const errorResponse = await response.json();
                message.error(errorResponse.message || errorResponse.error || "Failed to retrieve BID status.");
                if (errorResponse.message || errorResponse.error) {
                    resetFormState();
                    return true;
                }
            }

            return false;
        } catch (error) {
            return false;
        }
    };

    const handleBlur = (e) => {
        const name = e.target.name;
        const value = form[name]?.trim();

        if (name === "bid") {
            const errorMessage = validationService.validateBid(form.bid);
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: errorMessage,
            }));
        }
        if (form.bid) {
            UserLogin(form.bid);
        } else {
            setIsbnInput("");
            setForm({
                bid: "",
                title: "",
                author: "",
                publisher: "",
                isbN10: "",
                isbN13: "",
                bookPageCount: "",
                language: "",
                weight: "",
                isbn: "",
                condition: "",
                content: "",
                bookFormat: "",
                eqComplexityLevel: "",
                rackAndShelf: "",
                comments: "",
                reasonForException: "",
                formatException: "",
                updbookPageCount: "",
                qc: "",
                bidScanTime: "",
            });
            setCommentsList({});
            setLockBidInput(false);
            drawerOpenedForBid.current = null;
            setShowRoundNameButton(false);
        }
    };
    const populateFieldsByIsbn = async (bid) => {
        setForm((prev) => ({
            ...prev,
            bid: "",
        }));
        await UserLogin(bid);
    };
    const handleIsbnBlur = () => {
        if (form.bid && form.bid.trim() !== "" && form.bid.trim().length !== 16) {
            message.error("The BID should be 16 characters");
            return;
        } else if (form.bid && form.bid.trim() !== "") {
            const bidError = validationService.validateBid(form?.bid);
            if (bidError) {
                message.error(bidError);
                return;
            }
        }

        if (isbnInput.trim() !== "") {
            populateFieldsByIsbn(isbnInput.trim());
        }
    };
    const handleSubmitIsbn = (e) => {
        setForm((prev) => ({
            ...prev,
            bid: "",
        }));
    };

    const handleIsbnInputChange = (e) => {
        const value = e.target.value;
        setIsbnInput(value);

        if (value.trim() === "") {
            setShowRoundNameButton(false);
            setIsbnInput("");
            setForm({
                bid: "",
                title: "",
                author: "",
                publisher: "",
                isbN10: "",
                isbN13: "",
                bookPageCount: "",
                language: "",
                weight: 0.75,
                isbn: "",
                condition: "",
                bookType: "",
                usedCondition: "",
                content: [],
                bookFormat: "",
                eqComplexityLevel: "",
                comments: "",
                reasonForException: "",
                formatException: "",
                rackAndShelf: "",
                rackShelf: "",
                version: 1.0,
                qc: "",
                updbookPageCount: "",
                bidScanTime: "",
                vendorName: "",
            });
            setCommentsList({});
            setBookCover("");
            setLockBidInput(false);
            setErrors({});
            drawerOpenedForBid.current = null;
        } else {
            setForm((prev) => ({ ...prev, bid: "" }));
        }
    };
    const lastEnterPressTime = useRef(0);
    const lastBidKeyTimeRef = useRef(0);
    const clearBidTimerRef = useRef(null);

    useEffect(() => {
        return () => {
            clearTimeout(clearBidTimerRef.current);
        };
    }, []);

    const handleIsbnKeyPress = (e) => {
        if (isReadOnly("bid")) {
            return;
        }

        if (e.key === "Enter") {
            e.preventDefault();
            const now = Date.now();
            if (now - lastEnterPressTime.current < 3000) {
                return;
            }
            lastEnterPressTime.current = now;
            if (form.bid && form.bid.trim() !== "" && form.bid.trim().length !== 16) {
                message.error("The BID should be 16 characters");
                return;
            } else if (form.bid && form.bid.trim() !== "") {
                const bidError = validationService.validateBid(form?.bid);
                if (bidError) {
                    message.error(bidError);
                    return;
                }
            }
            if (isbnInput.trim() !== "") {
                populateFieldsByIsbn(isbnInput);
            }
        }
    };

    const handleIsbnReadOnlyKeyDown = (e) => {
        if (!isReadOnly("bid")) {
            return;
        }

        // Let native copy/paste behave normally (no custom clipboard handling).
        const isCopyOrPasteShortcut =
            (e.ctrlKey || e.metaKey) && ["c", "v", "C", "V"].includes(e.key);
        if (isCopyOrPasteShortcut) {
            return;
        }

        if (e.key === 'Enter' || e.key === 'Tab') {
            return;
        }

        const currentTime = Date.now();
        const timeDiff = currentTime - lastBidKeyTimeRef.current;
        lastBidKeyTimeRef.current = currentTime;

        // A physical scanner sends characters within a few milliseconds of each
        // other, so only block keystrokes that arrive slowly (manual typing).
        // The very first keystroke (field currently empty) is always let through
        // so a scan burst never loses its first character.
        const isSlowManualKeystroke = timeDiff > 50 && e.currentTarget.value.length > 0;
        if (!isSlowManualKeystroke) {
            return;
        }

        e.preventDefault();
        setIsbnInput('');

        clearTimeout(clearBidTimerRef.current);
        clearBidTimerRef.current = setTimeout(() => {
            showManualEntryDisabledWarning();
        }, 300);
    };

    const fetchCommentCount = async (bid) => {
        if (!bid) return;

        try {
            const response = await fetch(CommonObj.Endpoints.GetComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    pageNo: 1,
                    pageSize: 10,
                    search: bid,
                }),
            });
            if (!response.ok) {
                throw new Error(`Status ${response.status}`);
            }
            const data = await response.json();
            setCommentsList(data);
        } catch (error) {
            console.error(`Failed to fetch comments`);
        }
    };
    const isValidPageCount =
        form?.bookPageCount !== "" &&
        form?.bookPageCount !== null &&
        form?.bookPageCount !== undefined &&
        Number(form?.bookPageCount) >= 0;

    const getRackAndShelfValidationError = () => {
        if (!form.rackAndShelf || !form.rackAndShelf?.trim()) {
            return "Rack and Shelf is required";
        }
        else if (
            removeSpaces(form?.rackShelf)?.toLowerCase() ===
            removeSpaces(form?.rackAndShelf)?.toLowerCase()
        ) {
            return "The Rack Shelf scanned must not be the same as current Rack Shelf.";
        }
        else if (regexLoaded) {
            const validation = regexService.validateRackShelf(form?.rackAndShelf?.trim());
            if (!validation.isValid) {
                return "Input format invalid: No matching pattern found.";
            }
        }
    };

    const handleRadioClick = () => {
        message.destroy();
        if (!form?.updbookPageCount) {
            message.warning(
                "Please enter the updated page count",
            );
        } else if (form.bookFormat !== "Exceptions" && !form?.eqComplexityLevel) {
            const newErrors = {};
            newErrors.eqComplexityLevel =
                "EQ-Complexity Level is required";
            setErrors(newErrors);
        } else {
            const rackAndShelfError = getRackAndShelfValidationError();
            if (rackAndShelfError) {
                setErrors((prev) => ({ ...prev, rackAndShelf: rackAndShelfError }));
                return;
            }

            setErrors((prev) => {
                const nextErrors = { ...prev };
                delete nextErrors.rackAndShelf;
                return nextErrors;
            });

            const errorMessage1 = validationService.validateBid(form.bid);
            errorMessage1 === "" &&
                isValidPageCount &&
                setVisible(true);
        }
    }
    const checkDelta = () => {
        if (form?.updbookPageCount) {
            message.destroy();
            let qcDelata = masterData?.qcDeltaCalculation[0]?.qcDelta;
            let qcDelata1 = 1 - qcDelata / 100;
            let qcDelata2 = 1 + qcDelata / 100;

            let deltaval1 = form.bookPageCount * qcDelata1;
            let deltaval2 = form.bookPageCount * qcDelata2;
            let alertCond =
                form.updbookPageCount >= deltaval1 && form.updbookPageCount <= deltaval2
                    ? "sucess"
                    : "failure";
            if (alertCond === "failure") {
                message.error(
                    "The Updated Page count crosses the " +
                    qcDelata +
                    "% variance threshold",
                );
            }
        }
    };
    function MasterRadio(item) {
        return (
            <div className="book-page-form-radio-button">
                <input
                    type="radio"
                    name={item?.name}
                    id="book-page-form-radio-binding-t1-book"
                    value={item?.data?.format}
                    checked={item?.value === item?.data?.format}
                    disabled
                    onChange={handleChange}
                />
                <label htmlFor="book-page-form-radio-binding-t1-book">
                    {item?.data?.format}
                </label>
            </div>
        );
    }
    function MasterCheckbox(item) {
        return (
            <div className="book-page-form-checkbox-button">
                <input
                    type="checkbox"
                    id="used-condition-content1"
                    name={item?.name}
                    value={item?.data?.fileType}
                    checked={form?.content?.includes(item?.data?.fileType)}
                    disabled
                    onChange={handleContentChange}
                />
                <label htmlFor="used-condition-content">{item?.data?.fileType}</label>
            </div>
        );
    }

    const handleNumericKeyDown = (event) => {
        if (["e", "E", "+", "-", "."].includes(event.key)) {
            event.preventDefault();
        }
    };

    const getInputClass = (value, baseClass = "book-page-form-input-text") => {
        const hasValue =
            value !== null &&
            value !== undefined &&
            (typeof value === "number" || String(value).trim() !== "");

        return `${baseClass}${hasValue ? " has-text" : ""}`;
    };
    const resetFormState = () => {
        setShowRoundNameButton(false);
        setIsbnInput("");
        setCommentsList([]);
        setErrors({});
        // setSelectedLanguage(""); 
        setForm({
            bid: "", title: "", author: "", publisher: "", isbN10: "", isbN13: "",
            bookPageCount: "", language: "", weight: "0.75", isbn: "", condition: "",
            bookType: "", usedCondition: "", content: [], bookFormat: "",
            eqComplexityLevel: "", rackAndShelf: "", comments: "",
            reasonForException: "", formatException: "", newRackShelf: "",
            rackShelf: "", version: "1.0", updbookPageCount: "", bidScanTime: "", vendorName: ""
        });
        setLockBidInput(false);
        drawerOpenedForBid.current = null;
    };
    const prepareSubmissionData = () => {
        return {
            bid: form.bid.trim(),
            updatedPageCount: form.updbookPageCount,
            isSelfFixed: false,
            userId: roleUserId,
            rackShelf: form?.rackAndShelf != "" ? form?.rackAndShelf.trim() : form.rackShelf.trim(),
            qcStatus: 1,
            ErrorCount: "",
            ErrorCommand: "",

            isbn: form.isbn,
            rackAndShelf: 1,
            title: form.title,
            author: form.author,
            publisher: form.publisher,
            isbN10: form.isbN10.trim(),
            isbN13: form.isbN13.trim(),
            pageCount: Number(form.bookPageCount),
            language: form.language,
            weight: form.weight || 0.75,
            format: form.bookFormat,
            condition: form.condition,
            usedCondition:
                form.usedCondition == "" || form.usedCondition == null
                    ? "0"
                    : form.usedCondition,
            content: Array.isArray(form.content)
                ? form.content.join(",")
                : form.content,
            eqComplexityLevel:
                form.bookFormat !== "Exceptions" ? form.eqComplexityLevel : undefined,
            formatException: Number(form.formatException) || 0,
            version: "1.0",
            bookCoverImageURL: bookCover,
            bookType: form.bookType,
            comments: form.comments ? form.comments : LogoText,
            bidScanTime: form.bidScanTime,
        }
    };
    const showRejectModal = (record) => {
        if (!validate()) return;

        const submissionData = prepareSubmissionData();
        setIsModalVisible(true);
        setRejectSubmissionData(submissionData);
    };
    return (
        <>
            <IntakeRejectSlide
                isModalVisible={isModalVisible}
                setIsModalVisible={setIsModalVisible}
                clearForm={resetFormState}
                title={"QC Reject"}
                oldRackandShelf={form?.rackShelf}
                rejectSubmissionData={rejectSubmissionData}
                onScannerOpen={(scanner) => { setActiveScanner(scanner) }}
                emptyDecode={() => { setDecodedResults([]) }}
                className="story-slider slider-with-footer"
                width={540}
            />
            <Modal
                title={`Scan ${activeScanner ? activeScanner : ""}`}
                open={!!activeScanner}
                onCancel={() => setActiveScanner(null)}
                footer={null}
                destroyOnClose
                className="scan-model-container"
                width={1000}
            >
                <div className="scan-modal">
                    <Html5QrcodePlugin
                        fps={30}
                        qrbox={{ width: 1000, height: 400 }}
                        aspectRatio={2.8}
                        disableFlip={false}
                        qrCodeSuccessCallback={onNewScanResult}
                        supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
                    />
                </div>
            </Modal>
            {visible && (
                <QCSliderUI
                    visible={visible}
                    width={600}
                    title="QC Failure Details"
                    onClose={() => {
                        setVisible(false);
                        setIsbnInput("");
                    }}
                    formdata={form}
                    clearForm={() => {
                        setForm({
                            bid: "",
                            title: "",
                            author: "",
                            publisher: "",
                            isbN10: "",
                            isbN13: "",
                            bookPageCount: "",
                            updbookPageCount: "",
                            language: "",
                            weight: "0.75",
                            isbn: "",
                            condition: "",
                            bookType: "",
                            usedCondition: "",
                            content: [],
                            bookFormat: "",
                            eqComplexityLevel: "",
                            rackAndShelf: "",
                            comments: "",
                            reasonForException: "",
                            formatException: "",
                            rackShelf: "",
                            version: "1.0",
                            qc: "",
                            bidScanTime: "",
                            vendorName: "",
                        });
                        setCommentsList({});
                        setErrors({});
                        setShowRoundNameButton(false);
                        setLockBidInput(false);
                        drawerOpenedForBid.current = null;
                    }}
                    datasource={masterData}
                    bid={form?.bid}
                    onScannerOpen={(scanner) => {
                        setDecodedResults([]);
                        setActiveScanner(scanner);
                    }}
                    emptyDecode={() => {
                        setDecodedResults([]);
                    }}
                    created={roleUserId}
                    updatedPagecnt={form?.updbookPageCount}
                    className="story-slider qc-failure-slider"
                />
            )}
            {bksvisible && (
                <SliderUI
                    visible={bksvisible}
                    width={450}
                    title="Book Slide"
                    onClose={() => setBksVisible(false)}
                    imageSrc={bookCover ? bookCover : BookCoverDummy}
                    bookTitle={form.title}
                    isbn={form.isbn}
                    bid={form.bid}
                    bookscover={true}
                    mode={processingMode}
                    className="story-slider"
                    modeBatch={text}
                    batchData={batchData}
                />
            )}
            <SliderUI
                visible={commentsvisible}
                width={390}
                title="Comments Slide"
                onClose={() => setCommentsVisible(false)}
                bookTitle={`Comments For BID : ${form.bid}`}
                commentsList={commentsList}
                commentsCount={commentCount}
                username={form.createdBy}
                form={form}
                setForm={setForm}
                saveComment={saveComment}
                load={load}
                className="story-slider comment-slider-drawer-1"
            />
            <ErrorCommentsSlider
                visible={reworkDrawerVisible}
                onClose={closeReworkDrawer}
                reworkData={reworkData}
                loading={loading}
                hasQcStatus={hasQcStatus}
            />
            <main className="book-page-main-container">
                <div className="book-page-container">
                    <div className="book-page-title-container no-padding-right">
                        <div className="book-page-title">
                            <span>
                                <img src={QCIcon} alt="Qc icon"></img>
                            </span>

                            <h2>Begin The QC Process</h2>
                        </div>
                        <div className="book-page-title-container-2">
                            <button
                                className="book-page-title-icon"
                                onClick={() => setBksVisible(true)}
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M4 6V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V9C20 7.34315 18.6569 6 17 6H4ZM4 6V5"
                                        stroke="#0009E2"
                                        strokeWidth="1.5"
                                    />
                                    <circle
                                        opacity="0.5"
                                        cx="12"
                                        cy="13"
                                        r="3"
                                        stroke="#009DDB"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M18 6.00002V6.75002H18.75V6.00002H18ZM15.7172 2.32614L15.6111 1.58368L15.7172 2.32614ZM4.91959 3.86865L4.81353 3.12619H4.81353L4.91959 3.86865ZM5.07107 6.00002V6.75002H18V6.00002V5.25002H5.07107V6.00002ZM18 6.00002H18.75V4.30604H18H17.25V6.00002H18ZM15.7172 2.32614L15.6111 1.58368L4.81353 3.12619L4.91959 3.86865L5.02566 4.61111L15.8232 3.0686L15.7172 2.32614ZM4.91959 3.86865L4.81353 3.12619C3.91638 3.25435 3.25 4.0227 3.25 4.92895H4H4.75C4.75 4.76917 4.86749 4.63371 5.02566 4.61111L4.91959 3.86865ZM18 4.30604H18.75C18.75 2.63253 17.2678 1.34701 15.6111 1.58368L15.7172 2.32614L15.8232 3.0686C16.5763 2.96103 17.25 3.54535 17.25 4.30604H18ZM5.07107 6.00002V5.25002C4.89375 5.25002 4.75 5.10627 4.75 4.92895H4H3.25C3.25 5.9347 4.06532 6.75002 5.07107 6.75002V6.00002Z"
                                        fill="#0009E2"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M10 19H14"
                                        stroke="#009DDB"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                { }
                            </button>
                            <div className="book-page-title-radio-group">
                                <p>
                                    Processing Mode:{" "}
                                    <span className="qc-single-processing">
                                        Single Processing
                                    </span>
                                </p>
                                { }
                            </div>
                        </div>
                    </div>

                    { }
                    <form
                        className="book-page-form no-right-padding qc-page-form"
                        onSubmit={handleSubmit}
                        onKeyDown={(e) => { if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') { e.preventDefault(); } }}
                        noValidate
                    >
                        <div className="flex-container-BID ">
                            <div className="book-page-camera-button-container multiple rounded-button">
                                <Input
                                    placeholder=""
                                    value={isbnInput}
                                    className={`${isbnInput ? "has-id" : ""}`}
                                    onChange={(e) => {
                                        handleIsbnInputChange(e);
                                    }}
                                    onBlur={() => {
                                        handleIsbnBlur();
                                    }}
                                    onKeyDown={(e) => {
                                        handleIsbnReadOnlyKeyDown(e);
                                        handleIsbnKeyPress(e);
                                    }}
                                     id="qc-bid-input-id"
                                />
                                {isbnInput.length === 0 && (
                                    <label>
                                        {isReadOnly("bid") ? "Scan " : "Enter / Scan "}BID Number Using “
                                        <strong>Camera Icon</strong>”
                                        <span className="form-required">*</span>
                                    </label>
                                )}
                                <button
                                    type="button"
                                    className="book-page-camera-button"
                                    data-track="qc-open-bid-scanner"
                                    onClick={() => {
                                        setDecodedResults([]);
                                        setActiveScanner("BID");
                                    }}
                                >
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="12"
                                            cy="13"
                                            r="3"
                                            stroke="#1C274C"
                                            strokeWidth="1.5"
                                        />
                                        <path
                                            opacity="0.5"
                                            d="M10 19.9999H14C16.8089 19.9999 18.2134 19.9999 19.2223 19.3258C19.659 19.0339 20.034 18.6589 20.3259 18.2222C21 17.2133 21 15.8088 21 12.9999C21 10.191 20.9999 8.78673 20.3257 7.77783C20.0339 7.34107 19.6589 6.96607 19.2221 6.67423C18.2132 6.00011 16.8088 6.00011 13.9999 6.00011H9.99985C7.19093 6.00011 5.78646 6.00011 4.77757 6.67423C4.34081 6.96607 3.96581 7.34107 3.67397 7.77783C3 8.7865 3 10.1903 3 12.998L3 12.9999C3 15.8088 3 17.2133 3.67412 18.2222C3.96596 18.6589 4.34096 19.0339 4.77772 19.3258C5.78661 19.9999 7.19108 19.9999 10 19.9999Z"
                                            stroke="#1C274C"
                                            strokeWidth="1.5"
                                        />
                                        <path
                                            d="M18 10H17.5"
                                            stroke="#1C274C"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            opacity="0.5"
                                            d="M14.5 3.5H9.5"
                                            stroke="#1C274C"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                            fill="url(#paint0_linear_273_6917)"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                            fill="url(#paint1_linear_273_6917)"
                                        />
                                        <defs>
                                            <linearGradient
                                                id="paint0_linear_273_6917"
                                                x1="22.601"
                                                y1="11.9503"
                                                x2="1.98296"
                                                y2="14.3301"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop stopColor="#033D9B" />
                                                <stop offset="1" stopColor="#29ACD5" />
                                            </linearGradient>
                                            <linearGradient
                                                id="paint1_linear_273_6917"
                                                x1="22.601"
                                                y1="11.9503"
                                                x2="1.98296"
                                                y2="14.3301"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop stopColor="#033D9B" />
                                                <stop offset="1" stopColor="#29ACD5" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </button>
                                <button
                                    type="button"
                                    className="book-page-camera-button-input-2"
                                    onClick={handleSubmitIsbn}
                                >
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967C9.67678 6.76256 9.67678 7.23744 9.96967 7.53033L12.4393 10L9.96967 12.4697C9.67678 12.7626 9.67678 13.2374 9.96967 13.5303C10.2626 13.8232 10.7374 13.8232 11.0303 13.5303L14.0303 10.5303C14.3232 10.2374 14.3232 9.76256 14.0303 9.46967L11.0303 6.46967ZM5.96967 6.46967C6.26256 6.17678 6.73744 6.17678 7.03033 6.46967L10.0303 9.46967C10.3232 9.76256 10.3232 10.2374 10.0303 10.5303L7.03033 13.5303C6.73744 13.8232 6.26256 13.8232 5.96967 13.5303C5.67678 13.2374 5.67678 12.7626 5.96967 12.4697L8.43934 10L5.96967 7.53033C5.67678 7.23744 5.67678 6.76256 5.96967 6.46967Z"
                                            fill="url(#paint0_linear_1900_8687)"
                                        />
                                        <defs>
                                            <linearGradient
                                                id="paint0_linear_1900_8687"
                                                x1="20.6"
                                                y1="9.94475"
                                                x2="-0.0696504"
                                                y2="12.0919"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop stopColor="#033D9B" />
                                                <stop offset="1" stopColor="#29ACD5" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </button>
                            </div>
                            {showRoundNameButton && (
                                <button
                                    type="button"
                                    className="round-btn"
                                    onClick={openReworkDrawer}
                                >
                                    {roundName}{" "}
                                    <span>
                                        <svg
                                            width="14"
                                            height="14"
                                            viewBox="0 0 14 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clipPath="url(#clip0_4317_52426)">
                                                <circle
                                                    opacity="0.5"
                                                    cx="7.0013"
                                                    cy="6.99935"
                                                    r="5.83333"
                                                    stroke="#DC1400"
                                                    strokeWidth="0.875"
                                                />
                                                <path
                                                    d="M6.125 5.25L7.875 7L6.125 8.75"
                                                    stroke="#DC1400"
                                                    strokeWidth="0.875"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4317_52426">
                                                    <rect width="14" height="14" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </span>
                                </button>
                            )}
                        </div>
                        <div className="book-page-form-container">
                            <div className="book-page-form-1">
                                <div className="field-group">
                                    <input
                                        id="bid"
                                        name="bid"
                                        className={getInputClass(form?.bid)}
                                        value={form?.bid}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        readOnly={isReadOnly("bid")}
                                        placeholder=""
                                        required
                                        disabled = {lockBidInput}
                                    />
                                    <label htmlFor="bid" className="label">
                                        BID <span className="form-required">*</span>
                                    </label>

                                    {errors?.bid && (
                                        <span className="error-msg">{errors?.bid}</span>
                                    )}
                                    { }
                                </div>

                                <div className="field-group">
                                    <input
                                        id="main-isbn"
                                        name="isbn"
                                        className={getInputClass(form?.isbn)}
                                        value={form?.isbn}
                                        onChange={handleChange}
                                        placeholder=""
                                        disabled
                                    />
                                    <label htmlFor="main-isbn" className="label">
                                        ISBN<span className="form-required">*</span>
                                    </label>
                                    {errors.isbn && (
                                        <span className="error-msg">{errors.isbn}</span>
                                    )}
                                </div>
                                <div className="field-group">
                                    <input
                                        id="isbN10"
                                        name="isbN10"
                                        className={getInputClass(form?.isbN10)}
                                        value={form.isbN10}
                                        onChange={handleChange}
                                        placeholder=""
                                        disabled
                                    />
                                    <label htmlFor="isbN10" className="label">
                                        ISBN-10<span className="form-required">*</span>
                                    </label>
                                    {errors.isbN10 && (
                                        <span className="error-msg">{errors.isbN10}</span>
                                    )}
                                </div>
                                <div className="field-group">
                                    <input
                                        id="isbN13"
                                        name="isbN13"
                                        className={getInputClass(form?.isbN13)}
                                        value={form.isbN13}
                                        onChange={handleChange}
                                        placeholder=""
                                        disabled
                                    />
                                    <label htmlFor="isbN13" className="label">
                                        ISBN-13<span className="form-required">*</span>
                                    </label>
                                    {errors.isbN13 && (
                                        <span className="error-msg">{errors.isbN13}</span>
                                    )}
                                </div>
                                {form.bookFormat !== "Exceptions" && (
                                    <div className="field-group">
                                        <select
                                            id="eqComplexityLevel"
                                            name="eqComplexityLevel"
                                            className={`book-page-form-input-text ${form.eqComplexityLevel ? "has-text" : ""
                                                }`}
                                            value={form.eqComplexityLevel || ""}
                                            onChange={handleChange}
                                            required
                                            disabled
                                        >
                                            <option value=""> </option>
                                            {Array.from(
                                                new Set(
                                                    masterData.eqComplexityLevelFormula
                                                        .map((formula) => formula.level)
                                                        .filter((level) => level),
                                                ),
                                            )
                                                .sort((a, b) => {
                                                    const numA = parseInt(a);
                                                    const numB = parseInt(b);
                                                    const letterA = a.slice(-1);
                                                    const letterB = b.slice(-1);

                                                    if (numA !== numB) return numA - numB;
                                                    return letterA.localeCompare(letterB);
                                                })
                                                .map((level) => (
                                                    <option key={level} value={level}>
                                                        {level}
                                                    </option>
                                                ))}
                                        </select>
                                        <label htmlFor="eqComplexityLevel" className="label">
                                            EQ-Complexity Level{" "}
                                            <span className="form-required">*</span>
                                        </label>
                                        {errors?.eqComplexityLevel && (
                                            <span className="error-msg">
                                                {errors.eqComplexityLevel}
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className="book-page-form-2">
                                <div className="field-group">
                                    <input
                                        id="title"
                                        name="title"
                                        className={getInputClass(form?.title)}
                                        value={form.title}
                                        onChange={handleChange}
                                        placeholder=""
                                        disabled
                                    />
                                    <label htmlFor="title" className="label">
                                        Title<span className="form-required">*</span>
                                    </label>
                                    {errors.title && (
                                        <span className="error-msg">{errors.title}</span>
                                    )}
                                </div>
                                <div className="field-group">
                                    <input
                                        id="author"
                                        name="author"
                                        className={getInputClass(form?.author)}
                                        value={form.author}
                                        onChange={handleChange}
                                        placeholder=""
                                        disabled
                                    />
                                    <label htmlFor="author" className="label">
                                        Author<span className="form-required">*</span>
                                    </label>
                                    {errors.author && (
                                        <span className="error-msg">{errors.author}</span>
                                    )}
                                </div>
                                <div className="field-group">
                                    <input
                                        id="publisher"
                                        name="publisher"
                                        className={getInputClass(form?.publisher)}
                                        value={form.publisher}
                                        onChange={handleChange}
                                        placeholder=""
                                        disabled
                                    />
                                    <label htmlFor="publisher" className="label">
                                        Publisher<span className="form-required">*</span>
                                    </label>
                                    {errors.publisher && (
                                        <span className="error-msg">{errors.publisher}</span>
                                    )}
                                </div>
                                <div className="field-group">
                                    <input
                                        id="bookPageCount"
                                        name="bookPageCount"
                                        className={getInputClass(form?.bookPageCount)}
                                        type="number"
                                        min="0"
                                        value={form.bookPageCount}
                                        onChange={handleChange}
                                        placeholder=""
                                        onKeyDown={handleNumericKeyDown}
                                        disabled
                                    />
                                    <label htmlFor="bookPageCount" className="label">
                                        Page Count <span className="form-required">*</span>
                                    </label>
                                    {errors.bookPageCount && (
                                        <span className="error-msg">{errors.bookPageCount}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <select
                                        id="language"
                                        name="language"
                                        className={getInputClass(form?.language)}
                                        value={form.language}
                                        onChange={handleChange}
                                        required
                                        disabled
                                    >
                                        <option value=""></option>
                                        {masterData.language.map((language) => (
                                            <option key={language.languageCode} value={language.languageCode}>
                                                {language.languageName}
                                            </option>
                                        ))}
                                    </select>
                                    <label htmlFor="language" className="label">
                                        Language <span className="form-required">*</span>
                                    </label>
                                    {errors.language && (
                                        <span className="error-msg">{errors.language}</span>
                                    )}
                                </div>
                            </div>

                            <div className="book-page-form-3">
                                <div className="book-page-form-3-bg">
                                    <div className="book-page-form-radio-container">
                                        <p className="book-page-form-radio-title">
                                            Binding <span className="form-required">*</span>
                                        </p>
                                        <div className="book-page-form-radio-button-container">
                                            <div className="book-page-form-radio-button">
                                                <input
                                                    type="radio"
                                                    name="bookType"
                                                    id="book-page-form-radio-text-book"
                                                    value="Textbook"
                                                    checked={form.bookType === "Textbook"}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                                <label htmlFor="book-page-form-radio-text-book">
                                                    Textbook
                                                </label>
                                            </div>
                                            <div className="book-page-form-radio-button">
                                                <input
                                                    type="radio"
                                                    name="bookType"
                                                    id="book-page-form-radio-trade-book"
                                                    value="Tradebook"
                                                    checked={form.bookType === "Tradebook"}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                                <label htmlFor="book-page-form-radio-trade-book">
                                                    Tradebook
                                                </label>
                                            </div>
                                        </div>
                                        {errors.bookType && (
                                            <span className="error-msg-rad">{errors.bookType}</span>
                                        )}
                                    </div>
                                    <div className="book-page-form-radio-container">
                                        <p className="book-page-form-radio-title">
                                            Condition <span className="form-required">*</span>
                                        </p>
                                        <div className="book-page-form-radio-button-container">
                                            <div className="book-page-form-radio-button">
                                                <input
                                                    type="radio"
                                                    name="condition"
                                                    id="book-page-form-radio-used-book"
                                                    value="New Book"
                                                    disabled
                                                    checked={form.condition === "New Book"}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="book-page-form-radio-used-book">
                                                    New Book
                                                </label>
                                            </div>
                                            <div className="book-page-form-radio-button">
                                                <input
                                                    type="radio"
                                                    name="condition"
                                                    id="book-page-form-radio-new-book"
                                                    value="Used Condition"
                                                    checked={form.condition === "Used Condition"}
                                                    disabled
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="book-page-form-radio-new-book">
                                                    Used Condition
                                                </label>
                                            </div>
                                        </div>
                                        {errors.condition && (
                                            <span className="error-msg-rad">{errors.condition}</span>
                                        )}
                                    </div>
                                    {form.condition === "Used Condition" && (
                                        <div className="book-page-form-radio-container">
                                            <p className="book-page-form-radio-title">
                                                Wear Level<span className="form-required">*</span>
                                            </p>
                                            <div className="book-page-form-radio-button-container">
                                                <div className="book-page-form-radio-button">
                                                    <input
                                                        type="radio"
                                                        name="usedCondition"
                                                        id="book-page-form-radio-acceptable-book"
                                                        value="Acceptable"
                                                        checked={form.usedCondition === "Acceptable"}
                                                        disabled
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="book-page-form-radio-acceptable-book">
                                                        Acceptable
                                                    </label>
                                                </div>
                                                <div className="book-page-form-radio-button">
                                                    <input
                                                        type="radio"
                                                        name="usedCondition"
                                                        id="book-page-form-radio-not-acceptable-book"
                                                        value="Unacceptable"
                                                        checked={form.usedCondition === "Unacceptable"}
                                                        disabled
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="book-page-form-radio-not-acceptable-book">
                                                        Unacceptable
                                                    </label>
                                                </div>
                                            </div>
                                            {errors.usedCondition && (
                                                <span className="error-msg-rad">
                                                    {errors.usedCondition}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    <div className="book-page-form-radio-container">
                                        <p className="book-page-form-radio-title">
                                            Book Type <span className="form-required">*</span>
                                        </p>
                                        <div className="book-page-form-radio-button-container">
                                            {masterData?.bookFormat?.length > 0
                                                ? masterData?.bookFormat?.map((item) => {
                                                    return item.format !== "Exceptions" && (
                                                        <MasterRadio
                                                            data={item}
                                                            name="bookFormat"
                                                            value={form?.bookFormat}
                                                        />
                                                    );
                                                })
                                                : ""}
                                        </div>
                                        {errors.bookFormat && (
                                            <span className="error-msg-rad">{errors.bookFormat}</span>
                                        )}
                                    </div>
                                    {form.bookFormat === "Exceptions" && (
                                        <div className="field-group" style={{ display: 'none' }}>
                                            <select
                                                id="formatException"
                                                name="formatException"
                                                className={getInputClass(form?.formatException)}
                                                value={form?.formatException || ""}
                                                defaultValue={form?.formatException || ""}
                                                onChange={handleChange}
                                                required
                                                disabled
                                                style={{ cursor: "no-drop", display: 'none' }}
                                                hidden
                                            >
                                                <option value=""></option>

                                                {masterData.bookFormatExceptions.map((exception) => (
                                                    <option key={exception.id} value={exception.id}>
                                                        {exception.exceptionType}
                                                    </option>
                                                ))}
                                            </select>
                                            <label htmlFor="formatException" className="label">
                                                Reason for Exception{" "}
                                                <span className="form-required">*</span>
                                            </label>
                                            {errors.formatException && (
                                                <span className="error-msg">
                                                    {errors.formatException}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    <div className="book-page-form-checkbox-container">
                                        <p className="book-page-form-checkbox-title">
                                            Content<span className="form-required">*</span>
                                        </p>
                                        <div className="book-page-form-checkbox-button-container">
                                            {masterData?.condition?.length > 0
                                                ? masterData?.condition?.map((item) => {
                                                    return (
                                                        <MasterCheckbox data={item} name="content" />
                                                    );
                                                })
                                                : ""}
                                        </div>
                                        {form?.content.length === 0 && errors?.content && (
                                            <span className="error-msg-rad">{errors?.content}</span>
                                        )}
                                    </div>
                                </div>
                                <div className="qc-update-container">
                                    <div className="qc-update-column">
                                        <div className="field-group">
                                            <input
                                                id="qc-bookPageCount"
                                                name="updbookPageCount"
                                                className={getInputClass(form?.updbookPageCount)}
                                                type="number"
                                                min="0"
                                                value={form?.updbookPageCount}
                                                onChange={handleChange}
                                                placeholder=""
                                                onBlur={checkDelta}
                                                onKeyDown={handleNumericKeyDown}
                                            />
                                            <label htmlFor="qc-bookPageCount" className="label">
                                                Updated Page Count{" "}
                                                <span className="form-required">*</span>
                                            </label>
                                            {errors.updbookPageCount && (
                                                <span className="error-msg">
                                                    {errors.updbookPageCount}
                                                </span>
                                            )}
                                        </div>
                                        <div className="qc-status qc-status-relative">
                                            <p className="qc-status-title">
                                                QC Status <span className="form-required">*</span>
                                            </p>

                                            <label className="qc-custom-radio">
                                                <input
                                                    type="radio"
                                                    name="qc"
                                                    value="Pass"
                                                    checked={form.qc === "Pass"}
                                                    onChange={handleChange}
                                                />
                                                <span className="icon pass">&#10003;</span> Pass
                                            </label>
                                            <label
                                                className="qc-custom-radio"
                                                onClick={() => handleRadioClick()}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        e.preventDefault();
                                                        handleRadioClick();
                                                    }
                                                }}
                                            >
                                                <input
                                                    type="radio"
                                                    name="qc"
                                                    value="Fail"
                                                    checked={form.qc === "Fail"}
                                                    onChange={handleChange}
                                                />
                                                <span className="icon fail">&#10005;</span> Fail
                                            </label>
                                            {errors?.qc && (
                                                <span className=" error-msg">{errors?.qc}</span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="qc-details-column">
                                        <div className="current-rack-self-container">
                                            <label htmlFor="current-rack-self" className="">
                                                Current Rack Shelf{" "}
                                                <span className="form-required">*</span>
                                            </label>
                                            <input
                                                id="current-rack-self"
                                                name="current-rack-self"
                                                className="current-rack-self-input norightpadding"
                                                value={form.rackShelf}
                                                onChange={handleChange}
                                                placeholder=""
                                            />
                                            {errors.rackShelf && (
                                                <span className="error-msg">{errors.rackShelf}</span>
                                            )}
                                        </div>
                                        <div className="book-page-form-scan-rack-container">
                                            <span className="form-required-rack">*</span>
                                            <input
                                                className="book-page-form-scan-rack-button"
                                                id="rackAndShelf"
                                                name="rackAndShelf"
                                                placeholder="Enter / Scan Rack Shelf Barcode"
                                                value={form.rackAndShelf}
                                                onChange={handleChange}
                                                required
                                            ></input>
                                            <button
                                                type="button"
                                                className="book-page-form-scan-rack-button-icon"
                                                data-track="qc-open-rack-scanner"
                                                onClick={() => {
                                                    setDecodedResults([]);
                                                    setActiveScanner("Rack & Shelf ID");
                                                }}
                                            >
                                                <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <circle
                                                        cx="12"
                                                        cy="13"
                                                        r="3"
                                                        stroke="#1C274C"
                                                        strokeWidth="1.5"
                                                    />
                                                    <path
                                                        opacity="0.5"
                                                        d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                                        stroke="#1C274C"
                                                        strokeWidth="1.5"
                                                    />
                                                    <path
                                                        d="M18 10H17.5"
                                                        stroke="#1C274C"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                    />
                                                    <path
                                                        opacity="0.5"
                                                        d="M14.5 3.5H9.5"
                                                        stroke="#1C274C"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                    />
                                                </svg>
                                                <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                                        fill="url(#paint0_linear_1086_13736)"
                                                    />
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                                        fill="url(#paint1_linear_1086_13736)"
                                                    />
                                                    <defs>
                                                        <linearGradient
                                                            id="paint0_linear_1086_13736"
                                                            x1="22.601"
                                                            y1="11.9503"
                                                            x2="1.98296"
                                                            y2="14.3301"
                                                            gradientUnits="userSpaceOnUse"
                                                        >
                                                            <stop stopColor="#033D9B" />
                                                            <stop offset="1" stopColor="#29ACD5" />
                                                        </linearGradient>
                                                        <linearGradient
                                                            id="paint1_linear_1086_13736"
                                                            x1="22.601"
                                                            y1="11.9503"
                                                            x2="1.98296"
                                                            y2="14.3301"
                                                            gradientUnits="userSpaceOnUse"
                                                        >
                                                            <stop stopColor="#033D9B" />
                                                            <stop offset="1" stopColor="#29ACD5" />
                                                        </linearGradient>
                                                    </defs>
                                                </svg>
                                            </button>
                                            <span className="error-msg-rad">
                                                {errors.rackAndShelf}
                                            </span>
                                        </div>
                                        <div className="field-group">
                                            <input
                                                id="vendorName"
                                                name="vendorName"
                                                className={getInputClass(form.vendorName)}
                                                value={form.vendorName}
                                                readOnly
                                            />
                                            <label htmlFor="vendorName" className="label">
                                                Vendor
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="book-page-form-4">
                                <div className="field-group">
                                    <button
                                        className="book-page-form-view-comments"
                                        type="button"
                                        onClick={() => openCommentsSlider(form.bid)}
                                    >
                                        {`View Comments (${commentCount})`}
                                    </button>
                                    <textarea
                                        id="comments"
                                        rows="4"
                                        value={form.comments}
                                        onChange={(e) =>
                                            setForm((prev) => ({ ...prev, comments: e.target.value }))
                                        }
                                        className={`${"book-page-form-input-textarea"} ${form.comments === "" ? "" : "has-text"
                                            }`}
                                    ></textarea>
                                    <label htmlFor="comments">Comments</label>
                                </div>
                            </div>
                        </div>

                        <div className="book-page-footer-container">
                            <div className="book-page-action-container">
                                <div></div>
                                <div className="book-page-buttons-container">
                                    <button className="accept-button" disabled={isDisabled}>
                                        Submit
                                    </button>
                                    {/* <button className="reject-button" type="button" disabled={isDisabled} onClick={() => showRejectModal()}>Reject</button> */}

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </main>
        </>
    );
};
export default QCForm;
